module.exports = __webpack_public_path__ + "img/Bear03.35862512.png";